import { toast } from 'react-toastify'

import { useUpdateURLSearchParams } from '@/hooks/useQuery'
import { useAddCustomerFields } from '@/queries/customerFields/useAddCustomerField'
import { CreateCustomerField } from '@/types/customerField'
import { sanitizeText } from '@/utils/sanitizeText'

import { CustomFieldsForm } from './CustomFieldsForm'
import { CustomFieldsFormModel } from './useCustomFieldsForm'

export const AddNewCustomFieldsForm = () => {
  const updateParams = useUpdateURLSearchParams()

  const { addCustomerField, isLoading } = useAddCustomerFields()

  const onFormSubmit = (data: CustomFieldsFormModel) => {
    const formattedPayload: CreateCustomerField = {
      label: data.label,
      name: sanitizeText(data.label),
      type: data.type as CreateCustomerField['type'],
      show_in_client_mapping: data.show_in_client_mapping ?? false,
    }

    addCustomerField(formattedPayload)
      .then(() => {
        toast.success('Custom field created')
        updateParams(['addNew', undefined])
      })
      .catch(() => {
        toast.error('Error creating custom field')
      })
  }

  return (
    <CustomFieldsForm
      {...{ onFormSubmit, isPending: isLoading, isNew: true }}
    />
  )
}
